import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import BuildIcon from '@material-ui/icons/Build';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import RealmDivision from './RealmDivision';
import { map } from 'global/lib/lodash';

export default function PerformRealmBuilder(props) {
  const builder = props.realm;
  const [active, setActive] = useState(false);

  const toggleActive = () => {
    setActive(!active);
  };

  return (
    <>
      <ListItem button onClick={() => toggleActive()}>
        <ListItemIcon>
          <BuildIcon />
        </ListItemIcon>
        <ListItemText primary={builder.name} />
      </ListItem>
      {active ? (
        <List>
          {map(builder.realms, (item) => {
            return <RealmDivision key={item.id} realm={item} />;
          })}
        </List>
      ) : (
        <></>
      )}
    </>
  );
}

PerformRealmBuilder.defaultProps = {
  realm: {},
  currentBuilder: '0',
  changeBuilder: () => {},
};

PerformRealmBuilder.propTypes = {
  realm: PropTypes.object,
  currentBuilder: PropTypes.string,
  changeBuilder: PropTypes.func,
};
